/**
 * SidebarBadge - Small "generating" indicator rendered on top of a sidebar
 * icon when one or more jobs are in flight for that tab. Hidden when count <= 0.
 */

import type { JSX } from 'react';

interface SidebarBadgeProps {
  count: number;
}

export function SidebarBadge({ count }: SidebarBadgeProps): JSX.Element | null {
  if (count <= 0) return null;
  const label = count > 1 ? `${count} generations in progress` : '1 generation in progress';
  return (
    <span
      className="absolute -top-1 -right-1 min-h-[18px] min-w-[18px] px-1 rounded-full
                 bg-purple-500 text-white text-[10px] font-semibold
                 flex items-center justify-center shadow-lg shadow-purple-500/50
                 ring-2 ring-black/40"
      aria-label={label}
      title={label}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse mr-0.5" />
      {count}
    </span>
  );
}
